import { GridColumnSettings } from '@/shared/types/grid';

export const hiddenColumn = <T>(options: { uid?: string; field: keyof T & string }): GridColumnSettings<T> => {
  const { uid, field } = options;

  return {
    uid: uid ?? field,
    field,
    visible: false,
    showInColumnChooser: false,
  };
};
